export default __webpack_public_path__ + "static/media/collapse.c38b022e.svg";